import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=789badb5&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=789badb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789badb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789badb5')) {
      api.createRecord('789badb5', component.options)
    } else {
      api.reload('789badb5', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=789badb5&scoped=true&", function () {
      api.rerender('789badb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/ccb2b-log/Detail.vue"
export default component.exports